import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Sidebar from "./components/Sidebar";

import User from "./pages/user";
import Customer from "./pages/customer";
import Home from "./pages/home";
import Auth from "./pages/auth";
import Payment from "./pages/payment";
import Revenue from "./pages/revenue";
import ChangeLog from "./pages/change_log";
import Incentive from "./pages/incentive";

import useStore from "./store";
import api from "./services/api";

function App() {
  const { setUser } = useStore();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        api.setToken(localStorage.getItem("access_token"));
        const res = await api.get("me");
        setUser(res.data.user);
      } catch (e) {
        console.log(e);
        setUser(null);
      }
      setLoading(false);
    })();
  }, []);

  if (loading) return <div className="p-5 text-center">Loading...</div>;

  return (
    <Router>
      <div className="flex">
        <Sidebar />
        <div className="flex-1 bg-gray-100 min-h-screen overflow-auto">
          <Routes>
            <Route
              path="/customer/*"
              element={<RestrictedRoute component={Customer} />}
            />
            <Route
              path="/user/*"
              element={<RestrictedRoute component={User} />}
            />
            <Route
              path="/revenue/*"
              element={<RestrictedRoute component={Revenue} />}
            />
            <Route
              path="/payment/*"
              element={<RestrictedRoute component={Payment} />}
            />
            <Route
              path="/change_log/*"
              element={<RestrictedRoute component={ChangeLog} />}
            />
            <Route
              path="/incentive/*"
              element={<RestrictedRoute component={Incentive} />}
            />
            <Route path="/auth/*" element={<Auth />} />
            <Route path="/" element={<RestrictedRoute component={Home} />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

const RestrictedRoute = ({ component: Component }) => {
  const { user } = useStore();
  if (!user) return <Navigate to="/auth" replace />;

  return <Component />;
};

export default App;
